module.exports = __webpack_public_path__ + "static/media/2.5c78cd19.jpg";